import Welcome from "./Welcome";
import TextPart from "./TextPart";
import Properties from "./Properties";
import PagesPart from "./PagesPart";
import ContactForm from "./ContactForm";

function FrontPage() {
    const welcomeTexts = {
        welcome: {
            topText: ["FULL SERVICE REAL ESTATE SPECIALIST", "Buying Property in Marbella & Costa de Sol? Welcome to a", "Full Service Real Estate Specialist"],
            middleText: ["ALLE NIEUWBOUW AAN DE COSTA BLANCA,COSTA DEL SOL EN COSTA CALIDA", "WELKOM", "BESCHIKBAAR IN ALLE VEILIGHEID VAN UW VERTROUWDE MAKELAAR"]
        },
        middle: {
            topText: ["FULL SERVICE REAL ESTATE SPECIALIST", "Buying Property in Marbella & Costa de Sol? Welcome to a", "Full Service Real Estate Specialist"],
            middleText: ["LEEF NU HET GOEDE LEVEN,NU HET HET WEER KAN!", "NU MEER DAN OOIT GENIETEN", "MET JE PLAATSELIJKE MAKELAAR MAKKELIJKER DAN OOIT."]
        }
    };

    const textPartsData = {

        first: {
            subTitle: "ONS VERHAAL",
            title: "STRAND PROPERTIES",
            text: "Bij STRAND Properties zijn wij gespecialiseerd in vastgoeden in en rond Marbella (Spanje). Wij bieden al onze klanten een piekfijne en persoonlijke service aan, zowel de kopers als verkopers. Al onze makelaars hebben uitstekende kennis van zaken en jarenlange ervaring met vastgoeden in Mar-bella. Wij kunnen alle vastgoeden op de markt in Costa del Sol aanbieden en zullen alles doen om het proces zo soepel mogelijk voor u te maken.\nUw wensen zijn onze prioriteiten. Wij streven ernaar uw verwachtingen te overtreffen en halen alles voor u uit de kast. Met onze passie voor design en ons oog voor visuele communicatie, brengen we het beste naar voren in de eigendommen die we verkopen. Wij begrijpen als geen ander de kracht van digitale marketing op de vastgoedmarkt. Strand Properties is meer dan een vastgoedkantoor; het\nDeelt u onze passie? Word dan snel lid van de Strand Family. Al onze klanten krijgen een Strand Family lidkaart met tal van voordelen. U krijgt een mooie korting op Scandinavisch design en meubi-lair, korting bij de beste vastgoedadvocaten in Marbella, speciale deals voor interieurdesign en -reno-vatie & exclusieve events voor Strand Family leden.\nStrand Properties – uitmuntende service van ons voor u."
        },
        second: {
            subTitle: "ONS VERHAAL",
            title: "STRAND PROPERTIES",
            text: "Bij STRAND Properties zijn wij gespecialiseerd in vastgoeden in en rond Marbella (Spanje). Wij bieden al onze klanten een piekfijne en persoonlijke service aan, zowel de kopers als verkopers. Al onze makelaars hebben uitstekende kennis van zaken en jarenlange ervaring met vastgoeden in Mar-bella. Wij kunnen alle vastgoeden op de markt in Costa del Sol aanbieden en zullen alles doen om het proces zo soepel mogelijk voor u te maken"
        }
    }


    return (
        <div>
            <Welcome text={welcomeTexts.welcome} short={true} search={true}/>
            <TextPart data={textPartsData.first} />
            <Properties />
            <PagesPart />
            <Welcome text={welcomeTexts.middle}/>
            <TextPart data={textPartsData.second} />
            <ContactForm/>
        </div>
    )
}

export default FrontPage;